import coursesFetchEpic from "./courses-fetch";
import countriesFetchEpic from "./countries-fetch";
import { combineEpics } from "redux-observable";

export default combineEpics(coursesFetchEpic, countriesFetchEpic);
